//meto el validator porque por alguna razón si no lo meto aquí el autoload lo ignora.
+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=a.extend({},c.DEFAULTS,d.data(),"object"==typeof b&&b),f=d.data("bs.validator");(f||"destroy"!=b)&&(f||d.data("bs.validator",f=new c(this,e)),"string"==typeof b&&f[b]())})}var c=function(b,d){this.$element=a(b),this.options=d,d.errors=a.extend({},c.DEFAULTS.errors,d.errors);for(var e in d.custom)if(!d.errors[e])throw new Error("Missing default error message for custom validator: "+e);a.extend(c.VALIDATORS,d.custom),this.$element.attr("novalidate",!0),this.toggleSubmit(),this.$element.on("input.bs.validator change.bs.validator focusout.bs.validator",a.proxy(this.validateInput,this)),this.$element.on("submit.bs.validator",a.proxy(this.onSubmit,this)),this.$element.find("[data-match]").each(function(){var b=a(this),c=b.data("match");a(c).on("input.bs.validator",function(){b.val()&&b.trigger("input.bs.validator")})})};c.INPUT_SELECTOR=':input:not([type="submit"], button):enabled:visible',c.DEFAULTS={delay:500,html:!1,disable:!0,custom:{},errors:{match:"Does not match",minlength:"Not long enough"},feedback:{success:"glyphicon-ok",error:"glyphicon-remove"}},c.VALIDATORS={"native":function(a){var b=a[0];return b.checkValidity?b.checkValidity():!0},match:function(b){var c=b.data("match");return!b.val()||b.val()===a(c).val()},minlength:function(a){var b=a.data("minlength");return!a.val()||a.val().length>=b}},c.prototype.validateInput=function(b){var c=a(b.target),d=c.data("bs.validator.errors");if(c.is('[type="radio"]')&&(c=this.$element.find('input[name="'+c.attr("name")+'"]')),this.$element.trigger(b=a.Event("validate.bs.validator",{relatedTarget:c[0]})),!b.isDefaultPrevented()){var e=this;this.runValidators(c).done(function(f){c.data("bs.validator.errors",f),f.length?e.showErrors(c):e.clearErrors(c),d&&f.toString()===d.toString()||(b=f.length?a.Event("invalid.bs.validator",{relatedTarget:c[0],detail:f}):a.Event("valid.bs.validator",{relatedTarget:c[0],detail:d}),e.$element.trigger(b)),e.toggleSubmit(),e.$element.trigger(a.Event("validated.bs.validator",{relatedTarget:c[0]}))})}},c.prototype.runValidators=function(b){function d(a){return b.data(a+"-error")||b.data("error")||"native"==a&&b[0].validationMessage||g.errors[a]}var e=[],f=a.Deferred(),g=this.options;return b.data("bs.validator.deferred")&&b.data("bs.validator.deferred").reject(),b.data("bs.validator.deferred",f),a.each(c.VALIDATORS,a.proxy(function(a,c){if((b.data(a)||"native"==a)&&!c.call(this,b)){var f=d(a);!~e.indexOf(f)&&e.push(f)}},this)),!e.length&&b.val()&&b.data("remote")?this.defer(b,function(){var c={};c[b.attr("name")]=b.val(),a.get(b.data("remote"),c).fail(function(a,b,c){e.push(d("remote")||c)}).always(function(){f.resolve(e)})}):f.resolve(e),f.promise()},c.prototype.validate=function(){var a=this.options.delay;return this.options.delay=0,this.$element.find(c.INPUT_SELECTOR).trigger("input.bs.validator"),this.options.delay=a,this},c.prototype.showErrors=function(b){var c=this.options.html?"html":"text";this.defer(b,function(){var d=b.closest(".form-group"),e=d.find(".help-block.with-errors"),f=d.find(".form-control-feedback"),g=b.data("bs.validator.errors");g.length&&(g=a("<ul/>").addClass("list-unstyled").append(a.map(g,function(b){return a("<li/>")[c](b)})),void 0===e.data("bs.validator.originalContent")&&e.data("bs.validator.originalContent",e.html()),e.empty().append(g),d.addClass("has-error"),f.length&&f.removeClass(this.options.feedback.success)&&f.addClass(this.options.feedback.error)&&d.removeClass("has-success"))})},c.prototype.clearErrors=function(a){var b=a.closest(".form-group"),c=b.find(".help-block.with-errors"),d=b.find(".form-control-feedback");c.html(c.data("bs.validator.originalContent")),b.removeClass("has-error"),d.length&&d.removeClass(this.options.feedback.error)&&d.addClass(this.options.feedback.success)&&b.addClass("has-success")},c.prototype.hasErrors=function(){function b(){return!!(a(this).data("bs.validator.errors")||[]).length}return!!this.$element.find(c.INPUT_SELECTOR).filter(b).length},c.prototype.isIncomplete=function(){function b(){return"checkbox"===this.type?!this.checked:"radio"===this.type?!a('[name="'+this.name+'"]:checked').length:""===a.trim(this.value)}return!!this.$element.find(c.INPUT_SELECTOR).filter("[required]").filter(b).length},c.prototype.onSubmit=function(a){this.validate(),(this.isIncomplete()||this.hasErrors())&&a.preventDefault()},c.prototype.toggleSubmit=function(){if(this.options.disable){var b=a('button[type="submit"], input[type="submit"]').filter('[form="'+this.$element.attr("id")+'"]').add(this.$element.find('input[type="submit"], button[type="submit"]'));b.toggleClass("disabled",this.isIncomplete()||this.hasErrors())}},c.prototype.defer=function(b,c){return c=a.proxy(c,this),this.options.delay?(window.clearTimeout(b.data("bs.validator.timeout")),void b.data("bs.validator.timeout",window.setTimeout(c,this.options.delay))):c()},c.prototype.destroy=function(){return this.$element.removeAttr("novalidate").removeData("bs.validator").off(".bs.validator"),this.$element.find(c.INPUT_SELECTOR).off(".bs.validator").removeData(["bs.validator.errors","bs.validator.deferred"]).each(function(){var b=a(this),c=b.data("bs.validator.timeout");window.clearTimeout(c)&&b.removeData("bs.validator.timeout")}),this.$element.find(".help-block.with-errors").each(function(){var b=a(this),c=b.data("bs.validator.originalContent");b.removeData("bs.validator.originalContent").html(c)}),this.$element.find('input[type="submit"], button[type="submit"]').removeClass("disabled"),this.$element.find(".has-error").removeClass("has-error"),this};var d=a.fn.validator;a.fn.validator=b,a.fn.validator.Constructor=c,a.fn.validator.noConflict=function(){return a.fn.validator=d,this},a(window).on("load",function(){a('form[data-toggle="validator"]').each(function(){var c=a(this);b.call(c,c.data())})})}(jQuery);

// Custom validations for bootstrap validator
customValidations= function(){

    var validatorOptions = {
        settings: {  // <-- not a valid option
            ignore: ":hidden:not('.chosen-select')"  // <- not considered at all
        },
        delay: 100,
        custom: {
            valchosen: function($el){
              if ($el.val() == ''){
                return false;
              }
              else{
                 return true; 
              }
            },
            cp: function ($el) {
                return validarCP($el.val());
            },
            telefono: function ($el) {
                return validarMovil($el.val()) || validarFijo($el.val());
            },
            dni: function ($el) {
                return validarDNI($el.val().toUpperCase());
            },
            mayoredad: function ($el) {
                _fecha = $el.val().split('/');
                
                if (esFechaValida(_fecha[0]+'-'+_fecha[1]+'-'+_fecha[2])){
                  if (validarMayorEdad(_fecha[0], _fecha[1], _fecha[2])){
                      return true;
                  }
                  else{
                      $el.closest('.form-group').attr('data-mensaje-error', 'Lo sentimos, debe de ser mayor de edad para participar.');
                      return false;
                  }
                }
                else{
                  $el.closest('.form-group').attr('data-mensaje-error', 'Por favor, introduzca un formato de fecha correcto (DD/MM/YYYY).');
                  return false;
                }
            },
            fecha: function ($el) {
                _fecha = $el.val().split('/');
                return esFechaValida(_fecha[0]+'-'+_fecha[1]+'-'+_fecha[2]); //dd/mm/aaaa
            },
            url: function ($el) {
                return validarURL($el.val());
            },            
            hora: function ($el) {
                //_fecha = $el.val().split('/');
                return esHora($el.val()); //hh/mm
            },
            mayorhoy: function($el){
                _fecha = $el.val().split('/');
                return validarMayorHoy(_fecha[0], _fecha[1], _fecha[2]);
            },
            fechalimite: function($el){
                _fecha = $el.val().split('/');
                return validarFechaLimite(_fecha[0], _fecha[1], _fecha[2]);
            },
            fechalimite2: function($el){
              _fecha = $el.val().split('/');
                
                if (esFechaValida(_fecha[0]+'-'+_fecha[1]+'-'+_fecha[2])){
                  if (validarFechaLimite2(_fecha[0], _fecha[1], _fecha[2])){
                      return true;
                  }
                  else{
                      $el.closest('.form-group').attr('data-mensaje-error', 'Lo sentimos, el producto tiene que ser adquirido dentro del período promocional.');
                      return false;
                  }
                }
                else{
                  $el.closest('.form-group').attr('data-mensaje-error', 'Por favor, introduzca un formato de fecha correcto (DD/MM/YYYY).');
                  return false;
                }
            },
            patron: function($el){
                if ($el.val() == '7702018493074'){
                  return true;
                }
                else{
                  return false;
                }
            },
            longitudfija: function($el){
                long = $el.attr('data-longitudfija');
                if ($el.val().length != long){
                  return false;
                }
                else{
                  return true;
                }
            },
            file: function ($el) {
                if ($el.closest('.form-group').attr('data-tipo-error') == 0){//todo ok
                    $($el).parents('.form-group').removeClass('has-error');
                    $($el).parents('.form-group').addClass('has-sucess');
                    span_file = $($el).attr('data-span_file');
                    $('#'+span_file).addClass('ticket-ok');
                    // $('#nombreImagen').trigger('change');
                    return true;
                }  
                else{
                    if ($el.closest('.form-group').attr('data-tipo-error') == 1){//no relleno
                          $($el).parents('.form-group').addClass('has-error');
                          $($el).parents('.form-group').removeClass('has-sucess');
                          span_file = $($el).attr('data-span_file');
                          $('#'+span_file).removeClass('ticket-ok');
                         // $('#nombreImagen').trigger('change');
                          $el.closest('.form-group').attr('data-mensaje-error', 'Por favor, adjunte un archivo válido. Recuerde que el archivo debe tener formato JPEG, PNG o PDF y no pesar más de 10MB.');
                          return false;
                    }
                    else{
                        if ($el.closest('.form-group').attr('data-tipo-error') == 2){//error tamaño
                            $($el).parents('.form-group').addClass('has-error');
                            $($el).parents('.form-group').removeClass('has-sucess');
                            span_file = $($el).attr('data-span_file');
                            $('#'+span_file).removeClass('ticket-ok');
                            $el.closest('.form-group').attr('data-mensaje-error', 'Por favor, adjunte un ticket de compra que no sobrepase los 10MB.');
                            return false;
                        }
                        else{ //error extensión
                            $($el).parents('.form-group').addClass('has-error');
                            $($el).parents('.form-group').removeClass('has-sucess');
                            span_file = $($el).attr('data-span_file');
                            $('#'+span_file).removeClass('ticket-ok');
                            $el.closest('.form-group').attr('data-mensaje-error', 'Por favor, adjunte un ticket en formato JPEG, PNG o PDF.');
                            return false;
                        }  

                    }  
                }
            }
        },
        errors: {
            cp: "Revisa el código postal",
            telefono: "Revisa el teléfono",
            dni: "Revisa el DNI",
            mayoredad: "Para participar en la promoción tienes que ser mayor de edad",
            fecha: "Introduce una fecha válida",
            url: "Introduce una URL válida",
            hora: "Introduce una hora válida en el formato indicado",
            file: "Selecciona un archivo",
            mayorhoy: "Selecciona una fecha posterior al día de hoy",
            fechalimite: "Selecciona una fecha anterior al 07/04/2018",
            fechalimite2: "Selecciona una fecha comprendida entre el 01/06/2018 y el 30/11/2018",
            valchosen : "Selecciona una opción",
            patron: "Debes introducir un código EAN válido de 13 dígitos.",
            longitudfija: "Debes introducir un código válido",
        },
        
    }

    return validatorOptions;

}


console.log("llego");

validarFicheroSize = function (_fichero){
  var fileSize = _fichero.files[0].size;
  if (fileSize > 10000000){
    return false;
  }
  return true;
}

validarFicheroExt = function (_fichero){
  var fileName = _fichero.files[0].name;
  _ext = _nom.slice((_nom.lastIndexOf(".") - 1 >>> 0) + 2);
  var validos = ['png', 'jpg', 'pdf', 'jpeg', 'PNG', 'JPG', 'JPEG', 'PDF'];
  if ($.inArray(_ext, validos) >= 0){
    return true;
  }
  return false;
}

esHora = function (_hora){// formato hh:mm

  hora = _hora.split(':');
  
  if (parseInt(hora[0]) < 0 || parseInt(hora[0])>24){
    return false;
  }
  if (parseInt(hora[1]) < 0 || parseInt(hora[1])>59){
    return false;
  }
  if (hora.length > 1){
    if (hora[1].length < 2){ //para no permitir algo del tipo 12:1
      return false;
    }
  }
  else {
      return false;
  }
  return true;

}

validarMayorHoy = function (_dia, _mes, _anno){
        day = _dia;
        month = _mes;
        year = _anno;
        //console.log(day+'-'+month+'-'+year);
        var date2 = new Date(year, month-1, day);
        //date2.setFullYear(year, month - 1, day);
        
        var hoy = new Date();
        dia = hoy.getDate();
        mes = hoy.getMonth();
        anio= hoy.getFullYear();
        
        var today = new Date(anio, mes, dia);

        //var today = new Date();
        
        
        if (date2<today)
        {   
            return false;
        }
          else
          {
              return true;
          }   
}
validarMayorEdad = function (_dia, _mes, _anno){

    day = _dia;
    month = _mes;
    year = _anno;
    //console.log(day+'-'+month+'-'+year);
    var mydate = new Date();
    mydate.setFullYear(year, month - 1, day);

    var maxDate = new Date();
    maxDate.setYear(maxDate.getFullYear() - 18);
    //console.log(maxDate);
    //console.log(mydate);
    if (maxDate < mydate) {
        return false;
    }
    return true;
}
validarFechaLimite = function (_dia, _mes, _anno){
    day = _dia;
    month = _mes;
    year = _anno;
        

    var date2 = new Date(year, month-1, day);
        //date2.setFullYear(year, month - 1, day);
    var flimite = new Date('2018', '3', '7');
        //console.log(date2);
        
    if (date2>flimite)
      {   
        return false;
      }
    else
     {
        return true;
      }   
}

validarFechaLimite2 = function(_dia, _mes, _anno){
    day = _dia;
    month = _mes;
    year = _anno;
        

    var date2 = new Date(year, month-1, day);
        //date2.setFullYear(year, month - 1, day);
    var flimite1 = new Date('2018', '5', '1'); //01/06/2018
    var flimite2 = new Date('2018', '10', '30'); //30/11/2018
        //console.log(date2);
        
    if (date2>=flimite1 && date2<=flimite2)
      {   
        return true;
      }
    else
     {
        return false;
      }   
}

function validarURL(str) {
  var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
  '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|'+ // domain name
  '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
  '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
  '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
  '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
  return pattern.test(str);
}


validarEmail = function (mail) {
  var exr = /^[0-9a-z_\-\.]+@[0-9a-z\-\.]+\.[a-z]{2,4}$/i;
  return exr.test(mail);
}
validarMovil = function (tlf) {
  var exr = /[6|7]\d{8}/;
  return exr.test(tlf);
}
validarFijo = function (tlf) {
  var exr = /9\d{8}/;
  return exr.test(tlf);
}
validarDNI2 = function (_dni){
  _dni = _dni.toUpperCase();
  var exr =  "(([X-Z]{1})([-]?)(\d{7})([-]?)([A-Z]{1}))|((\d{8})([-]?)([A-Z]{1}))";
  return exr.test(_dni);
}

isDigit = function (c){
     return ((c >= "0") && (c <= "9"))
}

letra_nif = function (dni){
    var numero = dni % 23 + 1;
    letra='TRWAGMYFPDXBNJZSQVHLCKET';
    letra=letra.substring(numero-1,numero);
    return letra;
}    
    
    
validar_nie = function (valor,numero_digitos){
     var i;
     var dni=valor;
     primera_letra = dni.charAt(0);
     if(primera_letra.toUpperCase()!="X" && primera_letra.toUpperCase()!="T" && primera_letra.toUpperCase()!="Y")
          return false;
         
     for (i = 1; i < numero_digitos; i++)
    {  
        var c = dni.charAt(i);
        if (!isDigit(c))
        {
            return false;
        }
    }
    var letra_introducido = letra_nif(dni.substring(1,numero_digitos+1));
    var letra_real = dni.charAt(numero_digitos+1);
    if (letra_introducido == letra_real.toUpperCase())
    {
        return true;
    }
    else
    {
        return false;
    }        
}

validar_nif = function (valor){
     var i;
     var dni=valor;
    
     if(dni.length<4){
          return false;    
     }
    
     for (i = 0; i < dni.length-1; i++)
    {  
        var c = dni.charAt(i);
        if (!isDigit(c))
        {
            return false;
        }
    }
    var letra_introducido = letra_nif(dni.substring(0,dni.length-1));
    var letra_real = dni.charAt(dni.length-1);
    if (letra_introducido == letra_real.toUpperCase())
    {
        return true;
    }
    else
    {
        return false;
    }
}    
    

validarDNI = function (valor) {

    if(valor.length<9) {
      return false;
    }
   
    dni = valor.toUpperCase();

    letra = valor.substring(valor.length - 1);
    numero = valor.substring(0, 8);

    if (numero.indexOf("X") >= 0){
      numero = numero.replace("X", 0);
    }
    if (numero.indexOf("Y") >= 0){
      numero = numero.replace("Y", 1);
    }
    if (numero.indexOf("Z") >= 0){
      numero = numero.replace("Z", 2);
    }
   
    // Si es un NIE hay que cambiar la primera letra por 0, 1 ó 2 dependiendo de si es X, Y o Z.
   
    modulo = numero % 23;
    letras_validas = "TRWAGMYFPDXBNJZSQVHLCKE";
    letra_correcta = letras_validas.substring(modulo, modulo+1);   //substr($letras_validas, $modulo, 1);
    //console.log('modulo = '+modulo);
    //console.log('letra = '+letra+', letra valida = '+letra_correcta+', numero = '+numero);
    if(letra_correcta!=letra) {
      return false;
    }else {
      return true;
    }


  //var exr = /6\d{8}/;
  //return exr.test(dni);
  //return ( validar_nif(valor) || validar_nie(valor,7) || validar_nie(valor,8) );
}


contadorTextArea = function (campo,limite) {
  if (campo.value.length > limite) campo.value = campo.value.substring(0, limite);
  
}

validaFechaDDMMAAAA = function (fecha){
  var dtCh= "-";
  var minYear=1900;
  var maxYear=2100;
  function isInteger(s){
    var i;
    for (i = 0; i < s.length; i++){
      var c = s.charAt(i);
      if (((c < "0") || (c > "9"))) return false;
    }
    return true;
  }
  function stripCharsInBag(s, bag){
    var i;
    var returnString = "";
    for (i = 0; i < s.length; i++){
      var c = s.charAt(i);
      if (bag.indexOf(c) == -1) returnString += c;
    }
    return returnString;
  }
  function daysInFebruary (year){
    return (((year % 4 == 0) && ( (!(year % 100 == 0)) || (year % 400 == 0))) ? 29 : 28 );
  }
  function DaysArray(n) {
    for (var i = 1; i <= n; i++) {
      this[i] = 31
      if (i==4 || i==6 || i==9 || i==11) {this[i] = 30}
      if (i==2) {this[i] = 29}
    }
    return this
  }
  function isDate(dtStr){
    var daysInMonth = DaysArray(12)
    var pos1=dtStr.indexOf(dtCh)
    var pos2=dtStr.indexOf(dtCh,pos1+1)
    var strDay=dtStr.substring(0,pos1)
    var strMonth=dtStr.substring(pos1+1,pos2)
    var strYear=dtStr.substring(pos2+1)
    strYr=strYear
    if (strDay.charAt(0)=="0" && strDay.length>1) strDay=strDay.substring(1)
    if (strMonth.charAt(0)=="0" && strMonth.length>1) strMonth=strMonth.substring(1)
    for (var i = 1; i <= 3; i++) {
      if (strYr.charAt(0)=="0" && strYr.length>1) strYr=strYr.substring(1)
    }
    month=parseInt(strMonth)
    day=parseInt(strDay)
    year=parseInt(strYr)
    if (pos1==-1 || pos2==-1){
      return false
    }
    if (strMonth.length<1 || month<1 || month>12){
      return false
    }
    if (strDay.length<1 || day<1 || day>31 || (month==2 && day>daysInFebruary(year)) || day > daysInMonth[month]){
      return false
    }
    if (strYear.length != 4 || year==0 || year<minYear || year>maxYear){
      return false
    }
    if (dtStr.indexOf(dtCh,pos2+1)!=-1 || isInteger(stripCharsInBag(dtStr, dtCh))==false){
      return false
    }
    return true
  }
  if(isDate(fecha)){
    return true;
  }else{
    return false;
  }
}

esFechaValida = function(fecha){
  if (fecha != undefined && fecha != "" ){
    if (!/^\d{2}\-\d{2}\-\d{4}$/.test(fecha)){
//      alert("formato de fecha no vÃ¡lido (dd/mm/aaaa)");
      return false;
    }
    var dia  =  parseInt(fecha.substring(0,2),10);
    var mes  =  parseInt(fecha.substring(3,5),10);
    var anio =  parseInt(fecha.substring(6),10);
  switch(mes){
    case 1:
    case 3:
    case 5:
    case 7:
    case 8:
    case 10:
    case 12:
      numDias=31;
      break;
    case 4: case 6: case 9: case 11:
      numDias=30;
      break;
    case 2:
      if (comprobarSiBisisesto(anio)){ numDias=29 }else{ numDias=28};
      break;
    default:
    //  alert("Fecha introducida errÃ³nea");
      return false;
  }
    if (dia>numDias || dia==0){
  //    alert("Fecha introducida errÃ³nea");
      return false;
    }
    return true;
  }
}
comprobarSiBisisesto = function(anio){
if ( ( anio % 100 != 0) && ((anio % 4 == 0) || (anio % 400 == 0))) {
  return true;
  }
else {
  return false;
  }
}

function validarCP(_cp){
    
    var exr = /^([1-9]{2}|[0-9][1-9]|[1-9][0-9])[0-9]{3}$/;
    return exr.test(_cp);

}


// Custom messages for own browser validations ****** ****** ****** ****** ****** ******
(function init_custom_validations(){
  var x = document.getElementsByClassName("input-nombre");
  var i;
  for (i = 0; i < x.length; i++) {
    x[i].addEventListener('invalid', function(e) {
      switch(true){
        case this.validity.valueMissing:
          this.setCustomValidity('Introduzca su nombre.'); 
          $(this).parents('.form-group').addClass('has-error');
          $(this).parents('.form-group').removeClass('has-success');
          break;
        default:
          this.setCustomValidity('');
          $(this).parents('.form-group').removeClass('has-error');
          $(this).parents('.form-group').addClass('has-success');
          e.preventDefault();
      } 
    }, false);  
  };
  var x = document.getElementsByClassName("input-apellido1");
  var i;
  for (i = 0; i < x.length; i++) {
    x[i].addEventListener('invalid', function(e) {
      switch(true){
        case this.validity.valueMissing:
          this.setCustomValidity('Introduzca su primer apellido.'); 
          $(this).parents('.form-group').addClass('has-error');
          $(this).parents('.form-group').removeClass('has-success');
          break;
        default:
          this.setCustomValidity('');
          $(this).parents('.form-group').removeClass('has-error');
          $(this).parents('.form-group').addClass('has-success');
          e.preventDefault();
      } 
    }, false);  
  };
  var x = document.getElementsByClassName("input-apellido2");
  var i;
  for (i = 0; i < x.length; i++) {
    x[i].addEventListener('invalid', function(e) {
      switch(true){
        case this.validity.valueMissing:
          this.setCustomValidity('Introduzca su segundo apellido.'); 
          $(this).parents('.form-group').addClass('has-error');
          $(this).parents('.form-group').removeClass('has-success');
          break;
        default:
          this.setCustomValidity('');
          $(this).parents('.form-group').removeClass('has-error');
          $(this).parents('.form-group').addClass('has-success');
          e.preventDefault();
      } 
    }, false);  
  };
  var x = document.getElementsByClassName("input-email");
  var i;
  for (i = 0; i < x.length; i++) {
    x[i].addEventListener('invalid', function(e) {
      switch(true){
        case this.validity.valueMissing:
          this.setCustomValidity('Introduzca su dirección de email.'); 
          $(this).parents('.form-group').addClass('has-error');
          $(this).parents('.form-group').removeClass('has-success');
          break;
        case this.validity.typeMismatch:
          this.setCustomValidity('Revise su dirección de email.'); 
          $(this).parents('.form-group').addClass('has-error');
          $(this).parents('.form-group').removeClass('has-success');
          break;
        default:
          this.setCustomValidity('');
          $(this).parents('.form-group').removeClass('has-error');
          $(this).parents('.form-group').removeClass('has-success');
          e.preventDefault();
      } 
    }, false);  
  };
  var x = document.getElementsByClassName("input-telefono");
  var i;
  for (i = 0; i < x.length; i++) {
    x[i].addEventListener('invalid', function(e) {
      switch(true){
        case this.validity.valueMissing:
          this.setCustomValidity('Introduzca su número de teléfono.'); 
          $(this).parents('.form-group').addClass('has-error');
          $(this).parents('.form-group').removeClass('has-success');
          break;
        default:
          this.setCustomValidity('');
          $(this).parents('.form-group').removeClass('has-error');
          $(this).parents('.form-group').addClass('has-success');
          e.preventDefault();
      } 
    }, false);  
  };
  var x = document.getElementsByClassName("input-movil");
  var i;
  for (i = 0; i < x.length; i++) {
    x[i].addEventListener('invalid', function(e) {
      switch(true){
        case this.validity.valueMissing:
          this.setCustomValidity('Introduzca su número de teléfono móvil.'); 
          $(this).parents('.form-group').addClass('has-error');
          $(this).parents('.form-group').removeClass('has-success');
          break;
        default:
          this.setCustomValidity('');
          $(this).parents('.form-group').removeClass('has-error');
          $(this).parents('.form-group').addClass('has-success');
          e.preventDefault();
      } 
    }, false);  
  };
})();

(function($) {
  $.fn.simpleAjaxForm = function(options) {
      console.log('carga');
        var defaults = {
            url: ($(this).prop("tagName")=='FORM')?$(this).attr('action'):$(this).data('url'),
            ajaxTarget:($(this).data('ajax-target'))?$(this).data('ajax-target'):'',
            data: ($(this).prop('tagName')=='FORM') ? $(this).serializeArray() : $(this).closest('form').serializeArray(),
            spinTarget: $(this).data('id-spin-target'),
            mensajeError: "Se ha producido un error al procesar su peticion",
            strType:($(this).prop("tagName")=='FORM')?$(this).attr('method'):(($(this).data('srttype'))?$(this).data('srttype'):'GET'),
            callback: ($(this).data('callback'))?$(this).data('callback'):function(obj,target, result){},
            formulario:$(this)//JB
        }

        var settings = $.extend( {}, defaults, options );
        if($(this).data('strtype')){
            settings.strType=$(this).data('strtype');
        }
        var url=settings.url,
            spinTarget=settings.spinTarget,
            ajaxTarget=settings.ajaxTarget,
            data=$(this).data('ajax-no-data') ? {} : settings.data,
            strType=settings.strType,
            callback=settings.callback,
            obj=($(this).prop("tagName")=='FORM')?$(this):$(this).closest('form');
            formulario=settings.formulario;

           
        dataType = (ajaxTarget == '')?'json':'html';


        /* JB para enviar archivos también */
        dataCampos=data;

        data = new FormData();    

        formulario.find('.js-fileformupload').each(function( index ) {
          nombreCampoFile=$(this).attr("name");
          $.each($(this)[0].files, function(i, file) {
            data.append(nombreCampoFile, file);
          });
        });          

        $.each(dataCampos,function(key,input){
            data.append(input.name,input.value);
        });


        $.ajax({
          url: url,
          data: data,
          cache: false,
          contentType: false,
          processData: false,
          type: 'POST',
          dataType: dataType
        })
        .done( function (result) {
            if (dataType == 'html'){
                $(ajaxTarget).html(result);                    
            }
            if ($.isFunction(window[callback])){window[callback](obj,ajaxTarget,result)}; // obj = formulario, ajaxTarget = target de los datos (puede ser = ''), result = resultado devuelto por el ajax

            
        })
        .fail(function() {
            result = '{"resultado":"KO","error":{"code":"90102","msg_error":"Ha ocurrido un error, vuelva a intentarlo más tarde."}}';
            if ($.isFunction(window[callback])){window[callback](obj,ajaxTarget,result)}; // obj = formulario, ajaxTarget = target de los datos (puede ser = ''), result = resultado devuelto por el ajax

        });

    };


      $('.js-enviar-form-con-validator').validator(customValidations()).on('submit', function (e) {
        // comprobamos si hay que enviarlo por ajax o se envía a una url directamente
        // Por defecto envía por ajax

        //oculto la caja de errores
        if ($(this).find(".cajaErrores").length>0){
          $(this).find(".cajaErrores").html("");
          $(this).find(".cajaErrores").fadeOut();
        }

        $(this).find(".chosen-select[required]").each(function(index, el) {
          if ($(this).val()==""){
            e.preventDefault();
            $(this).closest('.form-group').addClass('has-error');
          }else{
            $(this).closest('.form-group').removeClass('has-error');
          }
        });

        if ($(this).data('enviar-ajax') == undefined || $(this).data('enviar-ajax') == true){
          enviar_por_ajax = true;
        }else{
          enviar_por_ajax = false;
        }
        //console.log('enviar ajax = '+enviar_por_ajax);
        // Comprobamos si hay un campo input type:file
        if ($(this).find('input[type="file"]').length > 0  ){
          hay_archivos = true;
         $(".js-examinar").removeClass("hasErrors");
        }else{
          hay_archivos = false;
          $(".js-examinar").addClass("hasErrors");

        }
        //console.log('hay archivos = '+hay_archivos);
        // Revisamos errores
        if (e.isDefaultPrevented() ) {
          // Recoger los campos con error
          lista_errores = "<ul class='listaErrores'>";
          $(this).find('.has-error').each(function(index, element){
            if ($(this).data('mensaje-error') !== undefined && $(this).data('mensaje-error') !== ''){
              lista_errores += '<li>'+$(this).data('mensaje-error')+'</li>'; 
            }else{
              lista_errores += '<li>'+$(this).find('label').html()+'</li>';            
            }
          });
          lista_errores += '</ul>';

          // handle the invalid form...
          if ($(this).data('mensaje-error') !== undefined && $(this).data('mensaje-error') !== ''){
              if ($(this).find(".cajaErrores").length>0){
                $(this).find(".cajaErrores").html("Revisa todos los datos antes de continuar");
                $(this).find(".cajaErrores").fadeIn();
              }else{
                $('#modal-alerta').mostrar_msg("¡Lo sentimos!", $(this).data('mensaje-error')+lista_errores);
              }
          }else{
              if ($(this).find(".cajaErrores").length>0){
                $(this).find(".cajaErrores").html("Revisa todos los datos antes de continuar");
                $(this).find(".cajaErrores").fadeIn();
              }else{            
                $('#modal-alerta').mostrar_msg("¡Lo sentimos!", "Revisa todos los datos antes de continuar"+lista_errores);              
              }
          }

        } else {
          // No hay errores

          // Si hay que enviarlo por ajax ejecutamos simpleAjaxForm, si no, dejamos que haga el submit
          if (enviar_por_ajax){
            $(this).simpleAjaxForm();
            e.preventDefault();
          }

        }
      }); 


//ANTI-PASTE
    $('.anti-paste').bind("cut copy paste",function(e) {
        e.preventDefault();
    });


})(jQuery);

(function ($) {
    $.fn.mostrar_msg = function(_title, _msg){
        if ($(this).find('.modal-title').length && $(this).find('.modal-body').length){
            $(this).find('.modal-title').html(_title);
            $(this).find('.modal-body').html('<p>'+_msg+'</p>');
            $(this).modal();
        } else {
            alert(_title+": "+_msg);
        }
    };
 
}(jQuery));



// WEBPACK FOOTER //
// ./scripts/autoload/functions-forms.js